import type { Point } from './toPortInfo.tsx';
import type { ItemReference, Positionable } from './ListEdgeDetails.tsx';
import { GLOBAL_LOOPS_CONTAINER_TYPE } from './directionKeys.tsx';

export interface Options {
	providedGlobalLoopsContainerPosition: Point | undefined;
	defaultGlobalLoopsContainerPosition: Point | undefined;
	targetedItem: ItemReference | undefined;
	draggingItem: Positionable | undefined;
	movingItem: Positionable | undefined;
}

export const useGlobalLoopsContainer = ({
	providedGlobalLoopsContainerPosition,
	defaultGlobalLoopsContainerPosition,
	targetedItem,
	draggingItem,
	movingItem,
}: Options) => {
	let position = providedGlobalLoopsContainerPosition || defaultGlobalLoopsContainerPosition;
	const isDragging = draggingItem?.type === GLOBAL_LOOPS_CONTAINER_TYPE;
	const isMoving = movingItem?.type === GLOBAL_LOOPS_CONTAINER_TYPE;
	const isTargeted = targetedItem?.type === GLOBAL_LOOPS_CONTAINER_TYPE;

	if (isDragging) {
		position = draggingItem.position;
	}

	if (isMoving) {
		position = movingItem.position;
	}

	return {
		position,
		isTargeted,
		isDragging,
		isMoving,
	};
};
